(() => {
  const initialize = (root) => {
    if (root.dataset.oneshotReelsReady === 'true') return;

    const pauseButton = root.querySelector('.oneshot-reels__pause');
    if (!pauseButton) return;

    root.dataset.oneshotReelsReady = 'true';

    pauseButton.addEventListener('click', () => {
      const isPaused = root.classList.toggle('is-paused');
      pauseButton.setAttribute('aria-pressed', String(isPaused));
      pauseButton.textContent = isPaused ? 'Riprendi lo scorrimento' : 'Ferma lo scorrimento';
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            root.classList.toggle('is-out-of-view', !entry.isIntersecting);
          });
        },
        { threshold: 0.05 }
      );

      observer.observe(root);
    }

    const updateDocumentVisibility = () => {
      root.classList.toggle('is-document-hidden', document.hidden);
    };

    updateDocumentVisibility();
    document.addEventListener('visibilitychange', updateDocumentVisibility);
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-oneshot-reels]')) initialize(scope);
    scope.querySelectorAll?.('[data-oneshot-reels]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
